import CategoriaDialog from './CategoriaDialog';

export default CategoriaDialog;
